import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import EmailIcon from '@material-ui/icons/EmailOutlined'
import mapDispatchers from '../utilities/mapDispatchers'
import styles from './EmailAuthButton.icss'

class EmailAuthButton extends Component {
	constructor(props) {
		super(props)

		this.doEmailLogin = this.doEmailLogin.bind(this)
	}

	doEmailLogin() {
		this.props.appRedirect('/login/email')
	}


	render() {
		return (
			<Button
				classes={{ root: styles.button, label: styles.label }}
				fullWidth
				onClick={this.doEmailLogin}
			>
				<EmailIcon className={styles.logo} />
				<span className={styles.text}>{this.context.translate('Login with Email')}</span>
			</Button>
		)
	}
}

EmailAuthButton.propTypes = {
	appRedirect: PropTypes.func.isRequired
}

EmailAuthButton.contextTypes = {
	translate: PropTypes.func
}

export default connect(
	null,
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['appRedirect'])
)(EmailAuthButton)



// WEBPACK FOOTER //
// ./src/components/EmailAuthButton.jsx